<script setup lang="ts">
import { ref } from "vue";
import Footer from "./Footer.vue";
import Header from "./Header.vue";
import Sidebar from "./Sidebar.vue";

// Fullscreen toggle state
const isFullscreen = ref(false);

const toggleFullscreen = () => {
  isFullscreen.value = !isFullscreen.value;
};
</script>

<template>
  <div class="flex h-screen overflow-hidden bg-gray-50">
    <!-- Sidebar (hidden in fullscreen mode) -->
    <Sidebar v-if="!isFullscreen" />

    <!-- Main Content Area -->
    <div class="flex-1 flex flex-col overflow-hidden">
      <!-- Header (hidden in fullscreen mode) -->
      <Header v-if="!isFullscreen" />

      <!-- Page Content -->
      <main class="flex-1 overflow-y-auto relative">
        <!-- Fullscreen Toggle Button (top right corner) -->
        <button
          @click="toggleFullscreen"
          class="fixed top-20 right-6 z-40 p-2 bg-white border border-gray-300 rounded-lg shadow-md hover:bg-gray-50 transition-colors group"
          :title="isFullscreen ? 'Exit Fullscreen' : 'Enter Fullscreen'"
        >
          <!-- Expand Icon (when not fullscreen) -->
          <svg
            v-if="!isFullscreen"
            class="w-5 h-5 text-gray-600 group-hover:text-primary"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"
            />
          </svg>
          <!-- Compress Icon (when fullscreen) -->
          <svg
            v-else
            class="w-5 h-5 text-gray-600 group-hover:text-primary"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 9V4.5M9 9H4.5M9 9L3.75 3.75M9 15v4.5M9 15H4.5M9 15l-5.25 5.25M15 9h4.5M15 9V4.5M15 9l5.25-5.25M15 15h4.5M15 15v4.5m0-4.5l5.25 5.25"
            />
          </svg>
        </button>

        <RouterView />
      </main>

      <!-- Footer (hidden in fullscreen mode) -->
      <Footer v-if="!isFullscreen" />
    </div>
  </div>
</template>
